import React from "react";
import styled from "styled-components";
import { CheckedLink } from "../../reusables";

export default function WriteMessageSection() {
	return (
		<SectionWrapper>
			<div className="contents">
				<h2>Write Us a Message</h2>

				<p className="text-justify">
					For all general enquiries about our programs and events,
					please email us using the form below. A member of our team
					will get in touch with you, we value your time and interest
					in our Foundation. Together, we can make a positive impact
					in our community.
				</p>

				<div>
					<p className="">
						Email us: inquiryto3hfoundation@gmail.com
					</p>

					<p className="">
						Location: Vancouver & Surrey, British Columbia, Canada
					</p>
				</div>

				<p>
					Drop us a message using this link
					<CheckedLink link="https://bit.ly/3HContactUs">
						Contact us
					</CheckedLink>
				</p>
			</div>

			{/* <Form /> */}
		</SectionWrapper>
	);
}

const SectionWrapper = styled.section`
	display: flex;
	justify-content: center;
	align-items: flex-start;
	padding: 7.5rem;

	.contents {
		width: 80%;

		h2 {
			width: 100%;
			margin-bottom: 2rem;
			color: #024ca3;
			text-align: center;
		}

		> p {
			width: 100%;
			margin-bottom: 1.5rem;
			font-size: 0.95rem;
		}

		div {
			p {
				font-size: 0.9rem;
			}
		}

		a {
			margin-left: 5px;
			color: #024ca3;
			font-size: 0.99rem;
			text-decoration: underline;
		}
	}

	@media (max-width: 768px) {
		padding: 0 2rem;

		.contents {
			width: 100%;
			margin-bottom: 1.5rem;

			h2 {
				/* width: 80%; */
				margin-bottom: 1rem;
				font-size: 3rem;
				line-height: 3.5rem;
			}

			> p {
				width: 100%;
				margin-bottom: 1rem;
			}

			/* div {
				width: 50%;
			} */
		}
	}
`;
